// Versionen und Rollout: welche Instanz auf welchem Build läuft, Rollout je
// Mandant oder für alle — der Reihe nach, jeder im eigenen Wartungsfenster; ein
// gescheiterter hält die übrigen nicht auf und bleibt in Wartung (docs/11 12).
// Darunter die Plattform selbst (platform-update.tsx). Gewählt wird ein Build
// aus der Liste der Registry, getippt wird nichts.

import { useState } from "react";
import { post } from "../api/client";
import { useTenants } from "../api/queries";
import { PageHead } from "../app/page-head";
import { fmtDate } from "../lib/format";
import { errorText, runStateOf, stateOf } from "../lib/labels";
import { Link } from "../router/router";
import { Badge, ErrorNote, Note } from "../ui/badge";
import { Card } from "../ui/card";
import { ConfirmButton } from "../ui/confirm-button";
import { Check } from "../ui/field";
import { toast } from "../ui/toaster";
import { BuildSelect, useBuildChoice } from "./build-select";
import { PlatformUpdateCard } from "./platform-update";

export function VersionsView() {
  const query = useTenants();
  const choice = useBuildChoice(null);
  const [selected, setSelected] = useState<number[]>([]);
  const live = (query.data ?? []).filter((t) => t.state !== "draft");
  const newest = choice.query.data?.releases[0]?.build ?? null;

  const run = async (all: boolean) => {
    try {
      const res = await post<{ tenants: string[] }>("/rollout", { build: choice.value, all, tenant_ids: selected });
      toast(`Rollout gestartet: ${res.tenants.join(", ")}`);
      // Kurz warten, dann neu lesen — die Läufe sind dann angelegt.
      setTimeout(() => { setSelected([]); void query.refetch(); }, 1500);
    } catch (err) { toast(errorText(err), "error"); }
  };

  return (
    <>
      <PageHead title="Versionen" hint="Jeder grüne Build auf main ist ein vollständiger Satz Images — Mandanten und Plattform laufen je auf einem davon." />
      {query.isError ? <ErrorNote error={query.error} /> : null}
      {query.data ? (
        <>
          <Card title="Instanzen" flush>
            <div className="pf-table-wrap">
              <table className="pf-table">
                <thead><tr><th></th><th>Mandant</th><th>Build</th><th>Version (gemeldet)</th><th className="pf-hide-phone">Stand</th></tr></thead>
                <tbody>
                  {live.length ? live.map((t) => {
                    const [st, tone] = stateOf(t.state);
                    return (
                      <tr key={t.id}>
                        <td>
                          {t.state === "active" ? (
                            <Check
                              name="sel" value={String(t.id)} label="" ariaLabel={`${t.name || t.slug} auswählen`}
                              checked={selected.includes(t.id)}
                              onChange={(on) => setSelected((cur) => (on ? [...cur, t.id] : cur.filter((x) => x !== t.id)))}
                            />
                          ) : null}
                        </td>
                        <td>
                          <Link to={`/tenants/${t.id}/ops`}>{t.name || t.slug}</Link> <Badge tone={tone}>{st}</Badge>
                          {t.run?.kind === "rollout" ? <> <span className="pf-sub">Rollout {runStateOf(t.run.state)[0]}</span></> : null}
                        </td>
                        <td className="mono">
                          {t.build ?? "—"}
                          {newest && t.build && t.build !== newest ? <> <Badge tone="info">älter</Badge></> : null}
                        </td>
                        <td>{t.status?.version ?? "—"}</td>
                        <td className="pf-hide-phone pf-sub">{fmtDate(t.status_at)}</td>
                      </tr>
                    );
                  }) : <tr><td colSpan={5} className="pf-empty">Keine Instanzen</td></tr>}
                </tbody>
              </table>
            </div>
          </Card>
          <Card
            title="Rollout"
            hint="Die gewählten (oder alle aktiven) Mandanten nacheinander auf diesen Build. Den Fortschritt zeigt die Detailseite jedes Mandanten."
            foot={(
              <>
                <ConfirmButton disabled={!choice.value || !selected.length} onConfirm={() => run(false)} confirmLabel="Wirklich ausrollen?">Gewählte ausrollen</ConfirmButton>
                <ConfirmButton className="pf-btn pf-btn--primary" disabled={!choice.value} onConfirm={() => run(true)} confirmLabel="Wirklich alle?">Alle aktiven ausrollen</ConfirmButton>
              </>
            )}
          >
            <div className="pf-row"><BuildSelect choice={choice} /></div>
            <Note>Ein Rollout ist je Instanz ein Wartungsfenster: Images ziehen, laufende Turns abwarten (bis 15 Minuten), Migration, Start.</Note>
          </Card>
        </>
      ) : null}
      <PlatformUpdateCard />
    </>
  );
}
